// src/pages/OrdersPage.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ColumnsConfigModal from "../components/ColumnsConfigModal";
import OrdersFilterModal from "../components/OrdersFilterModal";
import PdfOptionsModal from "../components/PdfOptionsModal";
import { konftabelazlecenia } from "../assets";
import AssignOrdersModal from "../components/AssignOrdersModal"; // << DODANE
import { API_URL } from "../config";

// Import nowych gifów statusów
import {
  oczekujace,
  przydzielone,
  realizowanestatyczne,
  wstrzymane,
  walidacjastatyczne,
  zatwierdzone,
  fakturowanie,
  zamkniete,
} from "../assets";

import "./OrdersPage.css";

/* >>> NEW – odczyt bieżącego użytkownika */
const currentUser = JSON.parse(localStorage.getItem("user"));
/* <<< NEW */

// Domyślna konfiguracja widoczności kolumn
const defaultConfig = {
  nr_ref: true,
  tytul: true,
  osoba_wprowadzajaca_id: true,
  osoba_wykonujaca_id: true,
  rodzaj_zgloszenia: true,
  obszar_id: false,
  klient_id: false,
  osoba_zlecajaca: false,
  data_zlecenia: true,
  status: true,
  data_przyjecia: false,
  data_zakonczenia: true,
  data_zamkniecia: false,
  osoba_walidujaca_id: false,
  osoba_zamykajaca_id: false,
  waga: true,
  godziny: false,   
  material: false,  
};

// Domyślna konfiguracja filtrów – ustawienia początkowe, w przypadku braku zapamiętanych filtrów
const defaultFilters = {
  nrRef: { from: "", to: "" },
  waga: { selected: ["Bardzo Niski", "Niski", "Neutralny", "Wysoki", "Krytyczny"] },
  rodzaj_zgloszenia: { selected: ["Usługa", "Przegląd A", "Wewnętrzne", "Przegląd Z", "Reklamacja", "Awaria"] },
  status: { selected: ["Oczekujące", "Przydzielone", "Realizowane", "Wstrzymane", "Walidacja", "Fakturowanie", "Zatwierdzone"] },
  data_zlecenia: { from: "", to: "" },
  deadline: { from: "", to: "" },
  // Dla pól wielokrotnego wyboru – domyślnie pusty wybór
  osoba_wprowadzajaca_id: { selected: [] },
  osoba_wykonujaca_id: { selected: [] },
  osoba_walidujaca_id: { selected: [] },
  osoba_zamykajaca_id: { selected: [] },
  obszar_id: { selected: [] },
  klient_id: { selected: [] },
};

// Funkcja formatowania daty w formacie DD-MM-YYYY
function formatDate(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

// Funkcja customSort do obsługi sortowania niektórych pól (np. nr_ref, waga, data)
function customSort(a, b, field, sortOrder) {
  let result = 0;
  switch (field) {
    case "godziny":
      result = Number(a.total_hours || 0) - Number(b.total_hours || 0);
      break;
    case "material":
      result = Number(a.material_total || 0) - Number(b.material_total || 0);
      break;
    case "nr_ref": {
      const [numA, yearA] = a.nr_ref.split("/");
      const [numB, yearB] = b.nr_ref.split("/");
      result =
        parseInt(yearA, 10) - parseInt(yearB, 10) ||
        parseInt(numA, 10) - parseInt(numB, 10);
      break;
    }
    case "tytul":
      result = a.tytul.localeCompare(b.tytul);
      break;
    case "waga": {
      const priorityOrder = [
        "Bardzo Niski",
        "Niski",
        "Neutralny",
        "Wysoki",
        "Krytyczny",
      ];
      result = priorityOrder.indexOf(a.waga) - priorityOrder.indexOf(b.waga);
      break;
    }
    case "rodzaj_zgloszenia":
      result = a.rodzaj_zgloszenia.localeCompare(b.rodzaj_zgloszenia);
      break;
    case "osoba_wprowadzajaca_id": {
      const nameA = (a.first_name + " " + a.last_name).toLowerCase();
      const nameB = (b.first_name + " " + b.last_name).toLowerCase();
      result = nameA.localeCompare(nameB);
      break;
    }
    case "osoba_wykonujaca_id":
      result = String(a.osoba_wykonujaca_id).localeCompare(String(b.osoba_wykonujaca_id));
      break;
    case "status": {
      const statusOrder = [
        "Oczekujące",
        "Przydzielone",
        "Realizowane",
        "Wstrzymane",
        "Walidacja",
        "Zatwierdzone",
		"Fakturowanie",
        "Zamknięte",
      ];
      result = statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
      break;
    }
    case "data_zlecenia":
    case "data_zakonczenia":
    case "data_przyjecia":
    case "data_zamkniecia":
      result = new Date(a[field]) - new Date(b[field]);
      break;
    case "obszar_id":
      result = (a.area_name || "").localeCompare(b.area_name || "");
      break;
    case "klient_id":
      result = (a.client_name || "").localeCompare(b.client_name || "");
      break;
    case "osoba_zlecajaca":
      result = (a.osoba_zlecajaca || "").localeCompare(b.osoba_zlecajaca || "");
      break;
    case "osoba_walidujaca_id":
      result = (a.osoba_walidujaca || "").localeCompare(b.osoba_walidujaca || "");
      break;
    case "osoba_zamykajaca_id":
      result = (a.osoba_zamykajaca || "").localeCompare(b.osoba_zamykajaca || "");
      break;
    default:
      result = 0;
  }
  return sortOrder === "asc" ? result : -result;
}

// Funkcja zwracająca właściwy gif dla statusu
function getStatusGif(status) {
  switch (status) {
    case "Oczekujące":
      return oczekujace;
    case "Przydzielone":
      return przydzielone;
    case "Realizowane":
      return realizowanestatyczne;
    case "Wstrzymane":
      return wstrzymane;
    case "Walidacja":
      return walidacjastatyczne;
    case "Zatwierdzone":
      return zatwierdzone;
	case "Fakturowanie":
      return fakturowanie;
    case "Zamknięte":
      return zamkniete;
    default:
      return null;
  }
}

function OrdersPage() {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [columnsConfig, setColumnsConfig] = useState(() => {
    // Wczytaj z localStorage, jeśli istnieje, w przeciwnym razie użyj domyślnej
    const savedConfig = localStorage.getItem("ordersColumnsConfig");
    return savedConfig ? JSON.parse(savedConfig) : defaultConfig;
  });
  const [showColumnsModal, setShowColumnsModal] = useState(false);

  // Nowe stany dla filtrowania
  const [filters, setFilters] = useState(() => {
    const saved = localStorage.getItem("ordersFilters");
    return saved ? JSON.parse(saved) : defaultFilters;
  });
  const [showFiltersModal, setShowFiltersModal] = useState(false);

  // Nowe stany dla dostępnych danych (użytkownicy, obszary, klienci)
  const [availableUsers, setAvailableUsers] = useState([]);
  const [availableAreas, setAvailableAreas] = useState([]);
  const [availableClients, setAvailableClients] = useState([]);

  // ** DODANO: zaznaczone zlecenia i modal zbiorowy **
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [showBatchModal, setShowBatchModal] = useState(false);
  /* >>> NEW – flaga postępu zamykania */
  const [closing, setClosing] = useState(false);
  /* <<< NEW */

  // >>> DODANE: licznik + modal przydzielania (Admin/Moderator)
  const isAdminOrModerator =
    currentUser?.role === "Admin" || currentUser?.role === "Moderator";
  const [assignableCount, setAssignableCount] = useState(0);
  const [loadingAssignable, setLoadingAssignable] = useState(false);
  const [showAssignOrdersModal, setShowAssignOrdersModal] = useState(false);

  useEffect(() => {
    if (isAdminOrModerator) fetchAssignableCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdminOrModerator]);

  const fetchAssignableCount = async () => {
    setLoadingAssignable(true);
    try {
      const res = await fetch(`${API_URL}/orders`, {
        credentials: "include",
      });
      if (!res.ok) throw new Error("Błąd pobierania zleceń");
      const data = await res.json();
      const count = (data || []).filter((o) => {
        const execId = o.osoba_wykonujaca_id == null ? null : Number(o.osoba_wykonujaca_id);
        return execId === null || execId === 29;
      }).length;
      setAssignableCount(count);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingAssignable(false);
    }
  };
  // <<< DODANE

  /* =================================================================
   *  JEDYNA ZMIENIONA FUNKCJA: rozróżniamy PDF vs EXCEL
   * =============================================================== */
	async function handleGenerateBatch(options) {
	  try {
		/* ------------------ EXCEL ------------------ */
		if (options.type === "excel") {
		  const res = await fetch(
			`${API_URL}/orders/batch/excel?ids=${selectedOrders.join(",")}`,
			{ credentials: "include" }
		  );
		  if (!res.ok) throw new Error(`HTTP ${res.status}`);

		  const blob = await res.blob();
		  const url = URL.createObjectURL(blob);

		  const a = document.createElement("a");
		  a.href = url;
		  a.download = "Zlecenia.xlsx";
		  document.body.appendChild(a);
		  a.click();
		  a.remove();
		  URL.revokeObjectURL(url);

		  return;
		}

		/* ------------------- PDF ------------------- */
		if (options.type === "pdf") {
		  const { includeWorkTime, includeMaterials, includePrice } = options;

		  const params = new URLSearchParams({
			ids: selectedOrders.join(","),
			includeWorkTime: String(includeWorkTime),
			includeMaterials: String(includeMaterials),
			includePrice: String(includePrice),
		  }).toString();

		  const res = await fetch(`${API_URL}/orders/batch/pdf?${params}`, {
			credentials: "include",
		  });
		  if (!res.ok) throw new Error(`HTTP ${res.status}`);

		  const blob = await res.blob();
		  const url = URL.createObjectURL(blob);

		  const a = document.createElement("a");
		  a.href = url;
		  a.download = "Raport_Zbiorowy.pdf";
		  document.body.appendChild(a);
		  a.click();
		  a.remove();
		  URL.revokeObjectURL(url);

		  return;
		}
	  } catch (err) {
		console.error("Błąd pobierania raportu:", err);
		alert("Nie udało się pobrać raportu. Sprawdź konsolę.");
	  } finally {
		setShowBatchModal(false);
	  }
	}


  /* >>> NEW – masowe zamykanie wybranych zleceń -------------------- */
	async function handleBatchClose() {
	  if (selectedOrders.length === 0) return;

	  const ok = window.confirm(
		`Czy jesteś pewny, że chcesz zamknąć ${selectedOrders.length} zlecenia?`
	  );
	  if (!ok) return;

	  try {
		setClosing(true);

		await Promise.all(
		  selectedOrders.map((id) =>
			fetch(`${API_URL}/orders/${id}/close`, {
			  method: "POST",
			  headers: { "Content-Type": "application/json" },
			  credentials: "include",
			  body: JSON.stringify({ osoba_zamykajaca_id: currentUser.id }),
			})
		  )
		);

		await fetchOrders();
		setSelectedOrders([]);
	  } catch (err) {
		console.error("Błąd masowego zamykania:", err);
		alert("Nie udało się zamknąć wybranych zleceń.");
	  } finally {
		setClosing(false);
	  }
	}

  /* <<< NEW -------------------------------------------------------- */

  // Funkcje obsługujące zapis
  const handleSavePermanent = (config) => {
    setColumnsConfig(config);
    localStorage.setItem("ordersColumnsConfig", JSON.stringify(config));
    setShowColumnsModal(false);
  };

  const handleSaveTemporary = (config) => {
    setColumnsConfig(config);
    setShowColumnsModal(false);
    // Nie zapisujemy w localStorage – zmiany są tylko tymczasowe
  };

  const handleRestoreDefaults = () => {
    setColumnsConfig(defaultConfig);
    localStorage.setItem("ordersColumnsConfig", JSON.stringify(defaultConfig));
    setShowColumnsModal(false);
  };

  // Pobranie zleceń z backendu
  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await fetch(`${API_URL}/orders`, { credentials: "include" });
      if (!response.ok) throw new Error("Błąd podczas pobierania zleceń");
      const data = await response.json();
      setOrders(data);
    } catch (error) {
      console.error(error);
    }
  };

  // Pobieranie dostępnych użytkowników z API (tabela users)
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${API_URL}/orders/workers`,
          {
            credentials: "include",
          }
        );
        if (!response.ok) throw new Error("Błąd podczas pobierania użytkowników");
        const data = await response.json();
        setAvailableUsers(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchUsers();
  }, []);

  // Pobieranie dostępnych obszarów (tabela areas)
  useEffect(() => {
    const fetchAreas = async () => {
      try {
        const response = await fetch(
          `${API_URL}/orders/areas`,
          {
            credentials: "include",
          }
        );
        if (!response.ok) throw new Error("Błąd podczas pobierania obszarów");
        const data = await response.json();
        setAvailableAreas(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchAreas();
  }, []);

  // Pobieranie dostępnych klientów (tabela clients)
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch(
          `${API_URL}/orders/clients`,
          {
            credentials: "include",
          }
        );
        if (!response.ok) throw new Error("Błąd podczas pobierania klientów");
        const data = await response.json();
        setAvailableClients(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchClients();
  }, []);

  // Filtrowanie – uwzględnia zarówno searchText jak i nowe kryteria z obiektu filters
  const filteredOrders = orders.filter((order) => {
    // Filtrowanie wg wyszukiwarki (tytuł lub nr_ref)
    if (
      !order.tytul.toLowerCase().includes(searchText.toLowerCase()) &&
      !order.nr_ref.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return false;
    }

    // Filtrowanie zakresu dla nr.ref (format "XXXX/YYYY")
    if (filters.nrRef.from || filters.nrRef.to) {
      const [numPart] = order.nr_ref.split("/");
      const numericValue = parseInt(numPart, 10);
      if (filters.nrRef.from) {
        const fromVal = parseInt(filters.nrRef.from.split("/")[0], 10);
        if (numericValue < fromVal) return false;
      }
      if (filters.nrRef.to) {
        const toVal = parseInt(filters.nrRef.to.split("/")[0], 10);
        if (numericValue > toVal) return false;
      }
    }

    // Filtrowanie priorytetu (waga)
    if (filters.waga.selected.length && !filters.waga.selected.includes(order.waga)) {
      return false;
    }

    // Filtrowanie rodzaju zlecenia
    if (
      filters.rodzaj_zgloszenia.selected.length &&
      !filters.rodzaj_zgloszenia.selected.includes(order.rodzaj_zgloszenia)
    ) {
      return false;
    }

    // Filtrowanie statusu
    if (filters.status.selected.length && !filters.status.selected.includes(order.status)) {
      return false;
    }

    // Filtrowanie daty zgłoszenia
    if (filters.data_zlecenia.from && new Date(order.data_zlecenia) < new Date(filters.data_zlecenia.from)) {
      return false;
    }
    if (filters.data_zlecenia.to && new Date(order.data_zlecenia) > new Date(filters.data_zlecenia.to)) {
      return false;
    }

    // Filtrowanie DeadLine
    if (filters.deadline.from && new Date(order.deadline) < new Date(filters.deadline.from)) {
      return false;
    }
    if (filters.deadline.to && new Date(order.deadline) > new Date(filters.deadline.to)) {
      return false;
    }

    // Filtrowanie pól wielokrotnego wyboru – dla użytkowników, obszaru i klientów
    if (
      filters.osoba_wprowadzajaca_id.selected.length &&
      !filters.osoba_wprowadzajaca_id.selected.includes(String(order.osoba_wprowadzajaca_id))
    ) {
      return false;
    }
    if (
      filters.osoba_wykonujaca_id.selected.length &&
      !filters.osoba_wykonujaca_id.selected.includes(String(order.osoba_wykonujaca_id))
    ) {
      return false;
    }
    if (
      filters.osoba_walidujaca_id.selected.length &&
      !filters.osoba_walidujaca_id.selected.includes(String(order.osoba_walidujaca_id))
    ) {
      return false;
    }
    if (
      filters.osoba_zamykajaca_id.selected.length &&
      !filters.osoba_zamykajaca_id.selected.includes(String(order.osoba_zamykajaca_id))
    ) {
      return false;
    }
    if (filters.obszar_id.selected.length && !filters.obszar_id.selected.includes(String(order.obszar_id))) {
      return false;
    }
    if (filters.klient_id.selected.length && !filters.klient_id.selected.includes(String(order.klient_id))) {
      return false;
    }

    return true;
  });

  // Sortowanie przefiltrowanych zleceń – używając customSort
  const sortedOrders = [...filteredOrders].sort((a, b) => {
    if (!sortField) return 0;
    return customSort(a, b, sortField, sortOrder);
  });

  // Handler zmiany sortowania – przy kliknięciu nagłówka kolumny
  const handleSort = (field) => {
    let newOrder = "asc";
    if (sortField === field && sortOrder === "asc") newOrder = "desc";
    setSortField(field);
    setSortOrder(newOrder);
  };

  const handleRowClick = (id) => {
    navigate(`/zlecenia/${id}`);
  };

  const handleNewOrder = () => {
    navigate("/zlecenia/nowe");
  };

  const handleArchive = () => {
    navigate("/zlecenia/archiwum");
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleConfigSave = (config) => {
    setColumnsConfig(config);
    setShowColumnsModal(false);
    localStorage.setItem("ordersColumnsConfig", JSON.stringify(config));
  };

  return (
    <div className="orders-page">
      <header
        className="orders-header"
        style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}
      >
        <h2>Zlecenia</h2>

        {/* >>> MOD – przyciski ułożone kolumnowo, a button „Zamknij…” pod spodem */}
        <div
          className="orders-header-buttons"
          style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "0.75rem" }}
        >
          {/* górny rząd standardowych akcji */}
          <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            <button className="btn-submit" onClick={handleNewOrder}>
              NOWE Zlecenie
            </button>
            <button className="btn-submit btn-archiwum" onClick={handleArchive}>
              Archiwum Zleceń
            </button>
            <button
              className="btn-submit"
              disabled={selectedOrders.length === 0}
              onClick={() => setShowBatchModal(true)}
            >
              Raport Zbiorowy
            </button>
            <button
              className="btn-config"
              onClick={() => setShowColumnsModal(true)}
              style={{ background: "transparent", border: "none", cursor: "pointer" }}
            >
              <img
                src={konftabelazlecenia}
                alt="Konfiguracja tabeli zleceń"
                style={{ width: "24px", height: "24px" }}
              />
            </button>
          </div>

          {/* dolny wiersz: Admin ma oba przyciski obok siebie */}
          {currentUser?.role === "Admin" && (
            <div style={{ display: "flex", gap: "1rem", alignSelf: "flex-end" }}>
              <button
                className="btn-submit"
                style={{ backgroundColor: "#800000", width: "320px" }}
                disabled={selectedOrders.length === 0 || closing}
                onClick={handleBatchClose}
              >
                Zamknij Wybrane Zlecenia ({selectedOrders.length})
              </button>

              {/* DODANE – Admin widzi również ten przycisk */}
              <button
                className="btn-submit"
                style={{
                  width: "max-content",
                  whiteSpace: "nowrap",
                  overflow: "visible",
                  textOverflow: "unset",
                }}
                disabled={loadingAssignable}
                onClick={() => setShowAssignOrdersModal(true)}
              >
                Zlecenia do Przydzielenia ({assignableCount})
              </button>
            </div>
          )}

          {/* Moderator – widzi tylko przycisk przydzielania */}
          {currentUser?.role === "Moderator" && (
            <button
              className="btn-submit"
              style={{
                width: "max-content",
                alignSelf: "flex-end",
                marginRight: "0.5rem",
                whiteSpace: "nowrap",
                overflow: "visible",
                textOverflow: "unset",
              }}
              disabled={loadingAssignable}
              onClick={() => setShowAssignOrdersModal(true)}
            >
              Zlecenia do Przydzielenia ({assignableCount})
            </button>
          )}
        </div>
        {/* <<< MOD */}
      </header>

      <section className="orders-controls" style={{ margin: "1rem 0" }}>
        <input
          type="text"
          placeholder="Wyszukaj zlecenie..."
          value={searchText}
          onChange={handleSearchChange}
          style={{ padding: "0.5rem", width: "250px", marginRight: "1rem" }}
        />
        <button className="btn-submit" onClick={fetchOrders}>
          Szukaj
        </button>
        <button
          className="btn-submit"
          style={{ marginLeft: "1rem" }}
          onClick={() => setShowFiltersModal(true)}
        >
          Filtry
        </button>
		<span
          className="orders-count-badge"
          title="Aktualnie wyświetlane zlecenia"
          aria-live="polite"
          aria-label={`Widoczne zlecenia: ${sortedOrders.length}`}
        >
          {sortedOrders.length}
        </span>
      </section>

      <section className="orders-table-container">
        <table className="orders-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={selectedOrders.length === sortedOrders.length && sortedOrders.length > 0}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedOrders(sortedOrders.map((o) => o.id));
                    } else {
                      setSelectedOrders([]);
                    }
                  }}
                />
              </th>
              {columnsConfig.nr_ref && <th onClick={() => handleSort("nr_ref")}>Nr.ref</th>}
              {columnsConfig.tytul && <th onClick={() => handleSort("tytul")}>Tytuł</th>}
              {columnsConfig.osoba_wprowadzajaca_id && (
                <th onClick={() => handleSort("osoba_wprowadzajaca_id")}>Zgłaszający</th>
              )}
              {columnsConfig.osoba_wykonujaca_id && (
                <th onClick={() => handleSort("osoba_wykonujaca_id")}>Przydzielony</th>
              )}
              {columnsConfig.rodzaj_zgloszenia && <th onClick={() => handleSort("rodzaj_zgloszenia")}>Rodzaj</th>}
              {columnsConfig.obszar_id && <th onClick={() => handleSort("obszar_id")}>Obszar</th>}
              {columnsConfig.klient_id && <th onClick={() => handleSort("klient_id")}>Klient</th>}
              {columnsConfig.osoba_zlecajaca && <th onClick={() => handleSort("osoba_zlecajaca")}>Zlecający</th>}
              {columnsConfig.data_zlecenia && <th onClick={() => handleSort("data_zlecenia")}>Data Zgłoszenia</th>}
              {columnsConfig.status && <th onClick={() => handleSort("status")}>Status</th>}
			  {columnsConfig.godziny && <th onClick={() => handleSort("godziny")}>Godziny</th>}
			  {columnsConfig.material && <th onClick={() => handleSort("material")}>Materiał</th>}
              {columnsConfig.data_przyjecia && <th onClick={() => handleSort("data_przyjecia")}>Data Przyjęcia</th>}
              {columnsConfig.data_zakonczenia && <th onClick={() => handleSort("data_zakonczenia")}>DeadLine</th>}
              {columnsConfig.data_zamkniecia && <th onClick={() => handleSort("data_zamkniecia")}>Data Zamknięcia</th>}
              {columnsConfig.osoba_walidujaca_id && <th onClick={() => handleSort("osoba_walidujaca_id")}>Walidujący</th>}
              {columnsConfig.osoba_zamykajaca_id && <th onClick={() => handleSort("osoba_zamykajaca_id")}>Zamykający</th>}
              {columnsConfig.waga && <th onClick={() => handleSort("waga")}>Priorytet</th>}
            </tr>
          </thead>
          <tbody>
            {sortedOrders.map((order) => (
              <tr key={order.id} onClick={() => handleRowClick(order.id)} style={{ cursor: "pointer" }}>
                <td onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    checked={selectedOrders.includes(order.id)}
                    onChange={(e) => {
                      const id = order.id;
                      setSelectedOrders((sel) => (e.target.checked ? [...sel, id] : sel.filter((x) => x !== id)));
                    }}
                  />
                </td>
                {columnsConfig.nr_ref && (
				  <td>
					<div className="nr-ref">
					  <span className="nr-ref-main">{order.nr_ref}</span>
					  {order.nr_klienta && (
						<span className="nr-ref-sub">{order.nr_klienta}</span>
					  )}
					</div>
				  </td>
				)}
                {columnsConfig.tytul && <td className="title-column">{order.tytul}</td>}
                {columnsConfig.osoba_wprowadzajaca_id && (
                  <td>
                    {order.first_name} {order.last_name}
                  </td>
                )}
                {columnsConfig.osoba_wykonujaca_id && (
                  <td>
                    {order.executor_first_name} {order.executor_last_name}
                  </td>
                )}
                {columnsConfig.rodzaj_zgloszenia && <td>{order.rodzaj_zgloszenia}</td>}
                {columnsConfig.obszar_id && <td>{order.area_name}</td>}
                {columnsConfig.klient_id && <td>{order.client_name}</td>}
                {columnsConfig.osoba_zlecajaca && <td>{order.osoba_zlecajaca}</td>}
                {columnsConfig.data_zlecenia && <td>{formatDate(order.data_zlecenia)}</td>}
                {columnsConfig.status && (
                  <td>
                    <img src={getStatusGif(order.status)} alt={order.status} className="status-gif" />
                  </td>
                )}
			    {columnsConfig.godziny && (
				  <td>{Number(order.total_hours || 0)}</td>
				)}
				{columnsConfig.material && (
				  <td>{Number(order.material_total || 0).toFixed(2)}&nbsp;zł</td>
				)}
                {columnsConfig.data_przyjecia && <td>{formatDate(order.data_przyjecia)}</td>}
                {columnsConfig.data_zakonczenia && <td>{formatDate(order.deadline)}</td>}
                {columnsConfig.data_zamkniecia && <td>{formatDate(order.data_zamkniecia)}</td>}
                {columnsConfig.osoba_walidujaca_id && (
                  <td>
                    {order.walidujaca_first_name} {order.walidujaca_last_name}
                  </td>
                )}
                {columnsConfig.osoba_zamykajaca_id && (
                  <td>
                    {order.zamykajaca_first_name} {order.zamykajaca_last_name}
                  </td>
                )}
                {columnsConfig.waga && <td>{order.waga}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* **Modal konfiguracji kolumn** */}
      {showColumnsModal && (
        <ColumnsConfigModal
          initialConfig={columnsConfig}
          onSavePermanent={handleSavePermanent}
          onSaveTemporary={handleSaveTemporary}
          onCancel={() => setShowColumnsModal(false)}
        />
      )}

      {/* **Modal filtrów** */}
      {showFiltersModal && (
        <OrdersFilterModal
          initialFilters={filters}
          onSavePermanent={(newFilters) => {
            setFilters(newFilters);
            localStorage.setItem("ordersFilters", JSON.stringify(newFilters));
            setShowFiltersModal(false);
          }}
          onSaveTemporary={(newFilters) => {
            setFilters(newFilters);
            setShowFiltersModal(false);
          }}
          onClear={() => {
            setFilters(defaultFilters);
            localStorage.removeItem("ordersFilters");
          }}
          onCancel={() => setShowFiltersModal(false)}
          userOptions={{
            osoba_wprowadzajaca_id: availableUsers,
            osoba_wykonujaca_id: availableUsers,
            osoba_walidujaca_id: availableUsers,
            osoba_zamykajaca_id: availableUsers,
          }}
          areaOptions={availableAreas}
          clientOptions={availableClients}
        />
      )}

      {/* **Modal PdfOptions dla raportu zbiorowego** */}
      {showBatchModal && (
        <PdfOptionsModal visible onClose={() => setShowBatchModal(false)} onGenerate={handleGenerateBatch} />
      )}

      {/* DODANE: modal przydzielania */}
      {showAssignOrdersModal && (
        <AssignOrdersModal
          visible
          onClose={() => {
            setShowAssignOrdersModal(false);
            fetchAssignableCount(); // odśwież licznik po zmianach
          }}
        />
      )}
    </div>
  );
}

export default OrdersPage;
